import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';

export default class TabsContentIconCardList {
    constructor() {
        this.sections = document.querySelectorAll('.components-block-tabs-content-icon-card-list');

        this.ready();
    }

    ready() {
        this.sections.forEach((section) => {
            let slider = section.querySelector('.swiper');
            let navigationPrev = section.querySelector('.slider-button-prev');
            let navigationNext = section.querySelector('.slider-button-next');
            let pagination = section.querySelector('.swiper-pagination-nav');

            const swiper = new Swiper(slider, {
                modules: [Navigation, Pagination],
                grabCursor: true,
                slidesPerView: 3,
                spaceBetween: 40,
                allowTouchMove: true,
                navigation: {
                    nextEl: navigationNext,
                    prevEl: navigationPrev,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        pagination: {
                            el: pagination,
                            type: 'fraction',
                        },
                    },
                    1024: {
                        slidesPerView: 3,
                        pagination: '',
                    },
                },
            });
        });
    }
}

if (document.querySelectorAll('.components-block-tabs-content-icon-card-list').length > 0) {
    new TabsContentIconCardList();
}
